import {
  Category,
  IService,
  IServiceData
} from '../index'

export interface ISolutionFilterData {
  category?: Category
}

export interface ISolutionData extends ISolutionFilterData {
  readonly id?: number
  name: string
  total?: number
  readiness_days?: number
  service: IServiceData[]
}

export interface ISolution extends ISolutionData {
  total: number
  service: IService[]

  validate(): boolean
  update(data?: ISolutionData): void
}

export interface ISolutionCompositionData {
  consultation?: number;
  plan?: number;
  services?: {
    [name: string]: number
  };
}

export interface ISolutionComposition extends ISolutionCompositionData {
  services: {
    [name: string]: number
  };
}

export const SOLUTION_NAME_MAX_LENGTH = 100
